import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { TMetaIntegrationStatus } from '@feathr/blackbox';
import { Pill } from '@feathr/components';
import {
  metaStatusColor,
  metaStatusLabel,
  metaStatusTooltip,
} from '@feathr/extender/styles/metaIntegration';

interface IMetaConnectedBadgeProps {
  status: TMetaIntegrationStatus;
}

function MetaConnectedBadge({ status }: Readonly<IMetaConnectedBadgeProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <Pill
      indicatorVariant={'solid'}
      name={'meta-connected-badge'}
      theme={metaStatusColor(status)}
      tooltip={metaStatusTooltip(t, status)}
      tooltipPosition={'bottom'}
      variant={'secondary'}
    >
      {metaStatusLabel(t, status)}
    </Pill>
  );
}

export default MetaConnectedBadge;
